module.exports = __webpack_public_path__ + "static/social-proof-16aa2f9fdadc953fde8ab57ad49b3136.jpg";